<script lang="ts">
    import Subject from "../../../application/SyllabusManager/models/Subject.ts";
    import Manager from "../../../application/SyllabusManager/models/Manager.ts";
    import Tutor from "../../../application/SyllabusManager/models/Tutor.ts";
    import ModalElement from "../ModalElement.svelte";
    import {_} from "svelte-i18n";

    export let subjectData: Subject;
    export let manager: Manager;
    let tutor : Tutor;
    $: tutor = manager.tutorManager.getTutor(subjectData.responsibleId);
</script>

<div class="divider">{$_('subjectCard.tutorInfo')}</div>
{#if tutor !== null}
    <ModalElement lead={$_('subjectCard.name')} text={tutor.name}/>
    <ModalElement lead={$_('subjectCard.email')} text={tutor.email}/>
{/if}
